import { Link } from '@zoomit/primitives';
import { isMobile } from '@zoomit/web-kit';
import { cssVar, theme, Typography } from '@zoomit/zoomit-ds';

import ReviewCircleProgress from '../shared/ReviewCircleProgress';
import ReviewBox from './ReviewBox';

type Props = {
  rate: string;
  countOfRates: number;
  href: string;
};

const UsersReviewBox = (props: Props) => {
  const { rate, countOfRates, href } = props;

  return (
    <Link href={href} style={{ textDecoration: 'none' }}>
      <ReviewBox>
        <ReviewCircleProgress rate={rate} />
        <div className="xs:items-center flex flex-col md:items-start">
          <Typography variant="subhead-bold" lineHeight={2}>
            امتیاز کاربران
          </Typography>
          {rate === '0' ? (
            <Typography variant="subhead" lineHeight={2} textColor={cssVar(theme.grey1)}>
              امتیازی ثبت نشده{isMobile ? '' : ' است'}
            </Typography>
          ) : (
            <Typography variant="subhead" lineHeight={2} textColor={cssVar(theme.grey1)}>
              از {countOfRates.toLocaleString('fa-IR')} رای
            </Typography>
          )}
        </div>
      </ReviewBox>
    </Link>
  );
};

export default UsersReviewBox;
